import { useState, useEffect } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Calendar } from "lucide-react";
import ScheduleCallForm from "./ScheduleCallForm";

export default function ExitIntent({
  controlled = false,
  controlledOpen = false,
  onControlledOpenChange = undefined
}: {
  controlled?: boolean;
  controlledOpen?: boolean;
  onControlledOpenChange?: (open: boolean) => void;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [hasShown, setHasShown] = useState(true); // Inicializado como true para evitar que se muestre
  const [showForm, setShowForm] = useState(false);

  // Si está en modo controlado, usar las props externas
  const effectiveIsOpen = controlled ? controlledOpen : isOpen;
  const effectiveSetIsOpen = controlled ? onControlledOpenChange || setIsOpen : setIsOpen;

  // Comentamos el useEffect para desactivar la detección de salida
  /*
  useEffect(() => {
    const handleMouseLeave = (e: MouseEvent) => {
      if (
        e.clientY <= 0 && // Si el mouse sale por la parte superior
        !hasShown && // Si no se ha mostrado antes
        !effectiveIsOpen // Si no está abierto actualmente
      ) {
        effectiveSetIsOpen(true);
        setHasShown(true);
      }
    };

    document.addEventListener('mouseleave', handleMouseLeave);
    return () => {
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [hasShown, effectiveIsOpen, effectiveSetIsOpen]);
  */

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      if (!showForm) {
        effectiveSetIsOpen(false);
        setShowForm(false);
      }
    } else {
      effectiveSetIsOpen(true);
    }
  };

  return (
    <div className="relative" style={{ zIndex: 9999 }}>
      <AlertDialog open={effectiveIsOpen} onOpenChange={handleOpenChange}>
        <AlertDialogContent
          className="bg-card/95 backdrop-blur-lg border border-border fixed"
          style={{ zIndex: 9999 }}
        >
          {!showForm ? (
            <>
              <AlertDialogHeader>
                <AlertDialogTitle className="flex items-center gap-2 text-2xl">
                  <Calendar className="w-6 h-6 text-[#FCAA0D]" />
                  ¡Espera un momento!
                </AlertDialogTitle>
                <AlertDialogDescription className="text-base text-foreground/90">
                  Antes de irte, ¿te gustaría agendar una llamada con nuestro equipo?
                  Tenemos ofertas exclusivas para tu negocio.
                </AlertDialogDescription>
              </AlertDialogHeader>
              <AlertDialogFooter>
                <AlertDialogCancel className="bg-background/50 hover:bg-background/80">
                  No, gracias
                </AlertDialogCancel>
                <AlertDialogAction
                  className="bg-[#FCAA0D] hover:bg-[#FCAA0D]/90 text-white"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowForm(true);
                  }}
                >
                  ¡Sí, quiero agendar!
                </AlertDialogAction>
              </AlertDialogFooter>
            </>
          ) : (
            <ScheduleCallForm
              onSuccess={() => {
                setShowForm(false);
                effectiveSetIsOpen(false);
              }}
            />
          )}
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
